export default
`
<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 14.0005C0.3125 14.0005 0 13.688 0 13.2505V6.00049C0 2.68799 2.6875 0.000488281 6 0.000488281C9.3125 0.000488281 12 2.68799 12 6.00049V13.2505C12 13.688 11.6562 14.0005 11.25 14.0005C10.8125 14.0005 10.5 13.688 10.5 13.2505V6.00049C10.5 3.53174 8.46875 1.50049 6 1.50049C3.5 1.50049 1.5 3.53174 1.5 6.00049V13.2505C1.5 13.688 1.15625 14.0005 0.75 14.0005Z" fill="currentColor"/>
</svg>
`;